import {createContext, useContext, useEffect, useState} from "react";
import {useConfigModule} from "base/provider";

let MapConfigContext = createContext(null);

export default function MapConfigProvider({children}) {
    const {moduleFilter} = useConfigModule();

    // From ModuleProvider moduleFilter initializes mapFilter
    const [mapFilter, setMapFilter] = useState({...moduleFilter, buffer: 0});

    // And this component have to check changes in moduleFilter to update mapFilter
    useEffect(() => {
        const newMapFilter = {...mapFilter, ...moduleFilter};

        // Compare objects to avoid duplicate calls with same filter
        if (JSON.stringify(mapFilter) !== JSON.stringify(newMapFilter)) {
            setMapFilter({...mapFilter, ...moduleFilter});
        }
    }, [moduleFilter]);

    const getBuffer = () => {
        return mapFilter["buffer"];
    };

    const setBuffer = buffer => {
        setMapFilter({...mapFilter, buffer});
    };

    return (
        <MapConfigContext.Provider
            value={{
                mapFilter,
                getBuffer,
                setBuffer,
            }}
        >
            {children}
        </MapConfigContext.Provider>
    );
}

function useMapConfig() {
    return useContext(MapConfigContext);
}

export {useMapConfig};
